export default __webpack_public_path__ + "static/media/taka.41941f00.jpeg";